import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckOutlined = forwardRef<SVGSVGElement, SvgIconProps>(
  function CheckOutlined(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12,21.98723c-5.51579,0 -9.98723,-4.47143 -9.98723,-9.98723c0,-5.51579 4.47143,-9.98723 9.98723,-9.98723c5.51579,0 9.98723,4.47143 9.98723,9.98723c0,5.51579 -4.47143,9.98723 -9.98723,9.98723zm-1.53191,-5.89936l6.54139,-6.54139c0.41789,-0.41789 0.41789,-1.09541 0,-1.51329c-0.41789,-0.41789 -1.09541,-0.41789 -1.51329,0l-5.97013,5.97013l-1.40635,-1.40635c-0.41789,-0.41789 -1.09541,-0.41789 -1.51329,0c-0.41789,0.41789 -0.41789,1.09541 0,1.51329l2.18586,2.18587c0.41789,0.41789 1.09541,0.41789 1.51329,0c0.06395,-0.06395 0.11813,-0.134 0.16251,-0.20826l0.00001,0z" />
      </SvgIcon>
    )
  },
)

export default CheckOutlined
